import { $playerProfile } from '../../../../../app/backend/store';
import { convertGemsEffect } from '../../../../../app/backend/store/shop';
import Settings from '../../../../settings/Settings';
import Popup from '../../common/popup/Popup';
import Controller from '../../controller/Controller';
import Modules from '../../gui/modules/Modules';

const TITLE = 'OUT OF ENERGY';
const HEIGHT = 400;

const DESCRIPTION = {
    FONT: Settings.FONTS.LXGW_CYRILLIC_BOLD,
    SIZE: 36,
    TINT: 0xbeb9da,
    MAX_WIDTH: 540,
    LINE_SPACING: -10,
};

const AMOUNT = {
    FONT: Settings.FONTS.LXGW_CYRILLIC_BOLD,
    SIZE: 80,
    TINT: 0xffffff,
    TEXT: '+200',
};

export default class OutOfEnergy extends Popup {
    private description!: Phaser.GameObjects.BitmapText;
    private iconEnergy!: Phaser.GameObjects.Image;
    private amount!: Phaser.GameObjects.BitmapText;
    private bgButton!: Phaser.GameObjects.Image;
    private button!: Phaser.GameObjects.Image;
    private buttonFrens!: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene) {
        super(scene, TITLE, HEIGHT);

        this.setupDescription();
        this.setupAmount();
        this.setupButton();
        this.setupListeners();
    }

    private setupDescription(): void {
        const x = 0;
        const y = 0;

        this.description = this.scene.add.bitmapText(x, y, DESCRIPTION.FONT, this.scene.cache.json.get('i18n')['out_of_energy_description'], DESCRIPTION.SIZE, 1);
        this.description.setOrigin(0.5, 0);
        this.description.setTint(DESCRIPTION.TINT);
        this.description.setMaxWidth(DESCRIPTION.MAX_WIDTH);
        this.description.setLineSpacing(DESCRIPTION.LINE_SPACING);
        this.contentContainer.add(this.description);
    }

    private setupAmount(): void {
        const x = 0;
        const y = 180;

        this.iconEnergy = this.scene.add.image(x, y, 'atlas', 'gui/popups/out_of_energy/icon_energy_big');
        this.iconEnergy.setOrigin(0, 0.5);
        this.contentContainer.add(this.iconEnergy);

        this.amount = this.scene.add.bitmapText(x, y, AMOUNT.FONT, AMOUNT.TEXT, AMOUNT.SIZE);
        this.amount.setOrigin(0, 0.5);
        this.amount.setTint(AMOUNT.TINT);
        this.contentContainer.add(this.amount);

        const totalWidth = this.iconEnergy.displayWidth + this.amount.getTextBounds().local.width;
        const padding = 10;
        this.iconEnergy.x = -totalWidth / 2 - padding / 2;
        this.amount.x = this.iconEnergy.x + this.iconEnergy.displayWidth + padding / 2;
    }

    private setupButton(): void {
        const x = 0;
        const y = 360;

        this.bgButton = this.scene.add.image(x, y, 'atlas', 'gui/popups/out_of_energy/bg_button');
        this.contentContainer.add(this.bgButton);

        this.button = this.scene.add.image(x + 80, y, 'atlas', 'gui/popups/out_of_energy/button');
        this.contentContainer.add(this.button);

        const hardIcon = this.scene.add.image(x + 20, y - 4, 'atlas', 'gui/hard_currency/icon');
        hardIcon.setOrigin(0, 0.5)
        this.contentContainer.add(hardIcon);

        const hardAmount = this.scene.add.bitmapText(x + 90, y - 8, AMOUNT.FONT, '10', 70);
        hardAmount.setOrigin(0, 0.5);
        hardAmount.setTint(AMOUNT.TINT);
        this.contentContainer.add(hardAmount);

        this.button.setInteractive({ useHandCursor: true });
        this.button.on('pointerdown', async () => {
            // console.log('clicked on buy energy button')
            if ($playerProfile.getState().player_wallet.currency_hard < 10) {
                await this.hide();
                this.scene.events.emit(Modules.EVENTS.SHOW_SHOP)
            }
            else {
                const res = await convertGemsEffect('energy_1')
                if (res.player) {
                    await this.hide();
                    const { width, height } = this.scene.scale;
                    this.scene.events.emit('top_up_energy', { x: width / 2, y: height / 2 })
                }
            }
        }, this);


        this.buttonFrens = this.scene.add.image(x - 100, y, 'atlas', 'gui/popups/out_of_energy/button');
        this.buttonFrens.setDisplaySize(this.button.width / 2, this.button.height);
        this.contentContainer.add(this.buttonFrens);

        const icon = this.scene.add.image(x - 100, y, 'atlas', 'gui/friends/Invite_friend icon');
        icon.setOrigin(0.5);
        this.contentContainer.add(icon);


        this.buttonFrens.setInteractive({ useHandCursor: true });
        this.buttonFrens.on('pointerdown', () => {
            this.hide();

            this.scene.events.emit('modules.show_friends');
        }, this);
    }

    private setupListeners(): void {
        this.scene.events.on(Controller.EVENTS.OUT_OF_ENERGY, this.show, this);
    }

    destroy(fromScene?: boolean): void {
        this.scene.events.off(Controller.EVENTS.OUT_OF_ENERGY, this.show, this);
        super.destroy(fromScene);
    }
}
